import React from 'react';
import PropTypes from 'prop-types';

function SocialButtons({ children, referenceId, onClick }) {
  return (
    <div id={referenceId} className="social-buttons" onClick={onClick}>
      {children}
    </div>
  );
}

SocialButtons.propTypes = {
  children: PropTypes.any,
  referenceId: PropTypes.string.isRequired,
  authLink: PropTypes.string,
  onClick: PropTypes.func
};

export default SocialButtons;
